import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { QCRule } from './types';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface TestQCRuleParams {
  fields: {
    field: string;
    value: string;
  }[];
  rule: QCRule;
}

const testRule: MutationFunction<QCRule, TestQCRuleParams> = async (args) => {
  if (isMockServices()) return await mock(_mockType);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<QCRule>('/rules/evaluate', {
    method: 'POST',
    body: {
      fields: args.fields,
      rule: args.rule,
    },
  });
  if (response.data) return response.data;
  throw new Error('Failed to test rule');
};

export default testRule;

const _mockType: QCRule = {
  name: 'Test Rule',
  expression: 'field1 > 10',
  evaluatedExpression: 'true',
  result: 'Pass',
  passMessage: 'Rule passed successfully',
  failMessage: 'Rule failed',
  errorMessage: 'Error evaluating rule',
};
